import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { RouterModule } from '@angular/router';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { GoogleChartsModule } from 'angular-google-charts';
import { ColorPickerModule } from 'ngx-color-picker';
import { ToastrModule } from 'ngx-toastr';
import { CalendarDemoComponent } from './framework/calendars/demo/calendar-demo/calendar-demo.component';
import { directivesComponents } from './directives/directives.components';
import { sharedFrameworkComponents } from './framework/sharedFramework.components';
import { iframeComponents } from './iframe/iframe.components';
import { BlackboardMessageComponent } from './personnel-files/components/blackboard-message/blackboard-message.component';
import { EmployeesViaGroupsComponent } from './personnel-files/components/employees-via-groups/employees-via-groups.component';
import { CustomPipesModule } from './pipes/pipe.module';
import { StyleGuideSettingsComponent } from './style-guides/style-guide-settings/style-guide-settings.component';
import { StyleGuideComponent } from './style-guides/style-guide/style-guide.component';

@NgModule({
    imports: [
        RouterModule,
        CustomPipesModule,
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        MatMenuModule,
        MatButtonModule,
        MatOptionModule,
        MatAutocompleteModule,
        MatChipsModule,
        MatIconModule,
        MatFormFieldModule,
        NgbModule,
        DragDropModule,
        AngularEditorModule,
        ColorPickerModule,
        ToastrModule.forRoot({
        }),
        GoogleChartsModule
    ],
    declarations: [
        ...directivesComponents,
        ...sharedFrameworkComponents,
        ...iframeComponents,
        EmployeesViaGroupsComponent,
        BlackboardMessageComponent,
        StyleGuideComponent,
        StyleGuideSettingsComponent,
        CalendarDemoComponent
    ],
    exports: [
        ...directivesComponents,
        ...sharedFrameworkComponents,
        ...iframeComponents,
        EmployeesViaGroupsComponent,
        BlackboardMessageComponent,
        StyleGuideComponent,
        StyleGuideSettingsComponent
    ],
})
export class SharedModule { }
